var mainIntro = new TimelineMax({paused: true, delay: '1.5'})
    .fromTo($('.tit-1'), 4, {y: 550, alpha: 0}, {y: 0, alpha: 1, ease: Power2.easeOut})
    .fromTo($('.tit-2'), 0.15, {scale: 10, alpha: 0}, {scale: 1, alpha: 1, ease: Power2.easeOut}, '+=0.2')
    .fromTo($('.tit-3'), 0.5, {y: 100, alpha: 0}, {y: 0, alpha: 1, ease: Power2.easeOut}, '+=1.8')
    .fromTo($('.tit-4'), 0.4, {y: 50, alpha: 0}, {y: 0, alpha: 1, ease: Power2.easeOut}, '-=0.3')
    .fromTo($('.btn-play'), 0.3, {y: 100, alpha: 0}, {y: 0, alpha: 1, ease: Power2.easeIn}, '-=0.4')
    .fromTo($('.btn-scroll'), 0.5, {y: 5, alpha: 0}, {y: 0, alpha: 1, ease: Power2.easeIn});

var player = promokit.store('video.player1');

promokit.preload({
  complete: function() {
    player.on('play', () => {mainIntro.play();});
    player.play();
  }
});

$('.btn-scroll').on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top}, 500, 'linear');
});



// WEBPACK FOOTER //
// ./src/js/index.js